"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _models = require("@seedlang/models");
var _root_store = _interopRequireDefault(require("./root_store"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var PaymentMigrationStore = /*#__PURE__*/function (_RootStore) {
  function PaymentMigrationStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, PaymentMigrationStore);
    _this = _callSuper(this, PaymentMigrationStore);
    _this.config = {
      model: _models.PaymentMigration,
      deserialize: true,
      GET: {
        index: '/payment_migrations',
        show: '/payment_migration'
      },
      POST: {
        createPaymentSetupSession: '/payment_migrations/create_payment_setup_session'
      },
      PUT: {
        update: '/payment_migrations/:paymentMigrationId'
      },
      DELETE: {
        destroy: '/payment_migrations/:paymentMigrationId'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(PaymentMigrationStore, _RootStore);
  return (0, _createClass2["default"])(PaymentMigrationStore, [{
    key: "createPaymentSetupSession",
    value: function createPaymentSetupSession(callback) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.api(params, callback, 'POST', 'createPaymentSetupSession');
    }
  }, {
    key: "updateMembershipPromise",
    value: function () {
      var _updateMembershipPromise = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(data) {
        var _this$showData;
        var paymentMigrationId, resp;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              paymentMigrationId = (_this$showData = this.showData) === null || _this$showData === void 0 ? void 0 : _this$showData.id;
              if (paymentMigrationId) {
                _context.next = 5;
                break;
              }
              _context.next = 4;
              return this.getShowPromise();
            case 4:
              paymentMigrationId = this.showData.id;
            case 5:
              _context.next = 7;
              return this.updatePromise({
                ids: {
                  paymentMigrationId: paymentMigrationId
                },
                data: data
              });
            case 7:
              resp = _context.sent;
              this.setShowData(resp.paymentMigration);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function updateMembershipPromise(_x) {
        return _updateMembershipPromise.apply(this, arguments);
      }
      return updateMembershipPromise;
    }()
  }]);
}(_root_store["default"]);
var _default = exports["default"] = new PaymentMigrationStore();